import type { PageContext } from 'vike/types';
import { initConnectionStore } from '../utils/initConnectionStore';
import { initEventId } from '../utils/initEventId';
import { useLanguageStore } from '../languageStore';

export const onBeforeRenderClient = (pageContext: PageContext) => {
  const { app } = pageContext;
  if (!app) {
    return;
  }

  hydratePinia(pageContext);

  initConnectionStore(pageContext);
  initEventId(pageContext);

  if (pageContext['locale']) {
    const languageStore = useLanguageStore();
    languageStore.setLanguage(pageContext.locale, true);
  }
};

const hydratePinia = (pageContext: PageContext) => {
  if (!pageContext.isHydration) {
    return;
  }

  const { pinia, _piniaInitialState } = pageContext;
  if (!pinia || !_piniaInitialState) {
    return;
  }

  pinia.state.value = _piniaInitialState;
};
